import React, { createContext, useState, useEffect, useContext } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { getDestinationClients } from "../lib/automatic";
import { ClientContext } from "../App";
import { getUserInfo } from "../lib/auth";
import { get } from "lodash";

const DestinationClientContext = createContext({
  clients: [],
  promiseInProgress: false,
});

export const useDestinationClientContext = () =>
  useContext(DestinationClientContext);

export const DestinationClientProvider = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [hasInitialized, setHasInitialized] = useState(false);
  const { platformClientId } = useContext(ClientContext);
  // Initialize usePromiseTracker with a specific area if you want to isolate its tracking
  const { promiseInProgress } = usePromiseTracker({
    area: "destination-client-fetching-area",
  });

  useEffect(() => {
    // Only fetch destination clients once during initialization
    if (!hasInitialized && platformClientId) {
      async function fetchDestinationClients() {
        try {
          const userData = await getUserInfo();
          const currentRole = get(userData, "attributes['custom:role']");
          const isPlatformRole =
            currentRole === "platform-admin" ||
            currentRole === "platform-member" ||
            (currentRole && currentRole.includes("platform"));

          if (isPlatformRole && platformClientId) {
            // Use trackPromise to show loading state
            trackPromise(
              getDestinationClients(platformClientId).then((clientsData) => {
                setClients(clientsData);
                setHasInitialized(true); // Mark as initialized after successful fetch
              }),
              "destination-client-fetching-area"
            );
          }
        } catch (error) {
          console.error("Error fetching destination clients:", error);
        }
      }

      fetchDestinationClients();
    }
  }, [platformClientId, hasInitialized]); // Only depend on platformClientId and initialization state

  return (
    <DestinationClientContext.Provider value={{ clients, promiseInProgress }}>
      {children}
    </DestinationClientContext.Provider>
  );
};
